module.exports = __webpack_public_path__ + "img/message-plus-square.3d4e0680.svg";